module.exports = __webpack_public_path__ + "static/media/sodaba.bc3d09d9.jpg";